import type { AppSummary } from './api';

export const CATALOG_SORTS = [
  { value: 'updated', label: 'Last updated' },
  { value: 'oldest', label: 'Oldest update' },
  { value: 'az', label: 'A → Z' },
  { value: 'za', label: 'Z → A' },
] as const;
export type CatalogSort = typeof CATALOG_SORTS[number]['value'];
const collator = new Intl.Collator('en', { sensitivity: 'base', numeric: true });

export function sortCatalogApps(apps: AppSummary[], sort: CatalogSort): AppSummary[] {
  const byName = (a: AppSummary, b: AppSummary) => collator.compare(a.title, b.title) || collator.compare(a.repo, b.repo);
  const timestamp = (app: AppSummary) => app.pushedAt ? Date.parse(app.pushedAt) : NaN;
  return [...apps].sort((a, b) => {
    if (sort === 'az') return byName(a, b);
    if (sort === 'za') return -byName(a, b);
    const left = timestamp(a), right = timestamp(b);
    if (!Number.isFinite(left) && Number.isFinite(right)) return 1;
    if (Number.isFinite(left) && !Number.isFinite(right)) return -1;
    return (Number.isFinite(left) && Number.isFinite(right) ? (sort === 'oldest' ? left - right : right - left) : 0) || byName(a, b);
  });
}
